class ConsoleLogger {
  log(payload: any): void {
    const level = payload.level ?? 'info';
    const consoleMethods: Record<string, (...args: any[]) => void> = {
      log: console.log,
      info: console.info,
      warn: console.warn,
      error: console.error,
      debug: console.debug,
    };
    const logFn = consoleMethods[level] || console.log;

    const enrichedPayload = {
      ...payload,
      timestamp: new Date().toISOString(),
      source: 'ConsoleLogger',
    };

    logFn(`[${enrichedPayload.timestamp}] [${level.toUpperCase()}]`, enrichedPayload);
  }
}
export const consoleLogger = new ConsoleLogger();
